/* ============================================================
   Golfstore - prijzen op de kaarten van "Complete IJzer Sets"

   Wordt geladen via snippets/cart-config.liquid en werkt alleen op die
   ene sectie. Twee dingen:

   1. Bij geconsolideerde producten (Titleist T-serie: losse ijzers en
      complete sets in hetzelfde product, onder de optie "Club") toont de
      kaart nu de laagste variantprijs - een los ijzer. Dit script zet de
      prijs van de 5-PW-set als hoofdprijs en het setformaat onder de titel.

   2. Onder de prijs komt "Los ijzer vanaf EUR x". Die prijs komt uit het
      product zelf (geconsolideerd) of uit het losse-ijzerproduct in LOSSE
      hieronder.

   De prijzen worden live uit de winkel gehaald (/products/<handle>.js), dus
   ze lopen nooit achter. Pas als de sectie in beeld komt, en het antwoord
   blijft in sessionStorage staan.

   Dit is een tussenoplossing: netter is dit in Liquid, in
   snippets/product-listing.liquid - die versie staat klaar in de repo
   (theme-changes/losse-ijzerprijs.liquid) en kan erin zodra het thema aan
   GitHub hangt. Gaat hier iets mis, dan blijft de kaart gewoon staan zoals
   hij was.
   ============================================================ */

(function () {
  "use strict";

  var ROOT_ID = "featured_collection--template--30994799329623__featured_collection_c9qrax";

  /* Sets waarvan het losse ijzer een apart product is. Sleutel = handle van
     de set, waarde = handle van het losse-ijzerproduct. */
  var LOSSE = {
    "callaway-quantum-max-ijzerset-5-pw-staal": "callaway-quantum-max-ijzers",
    "ping-g440-ijzerset-5-pw": "ping-g440-ijzers-los-ijzer",
    "ping-i540-ijzerset-5-uw": "ping-i540-ijzers-los-ijzer",
    "wilson-dynapwr-max-ijzerset-5-pw-graphite": "wilson-dynapwr-max-ijzers"
  };

  var SET_LABEL = "5-PW";
  var LABEL = "Los ijzer vanaf ";

  /* De notatie van de winkel overnemen (nu "EUR2,568.00") in plaats van er een
     te kiezen: we lezen een prijs die al op de pagina staat. Zet je de
     valutanotatie in Shopify later om, dan volgt dit vanzelf. */
  var money = { prefix: "€", suffix: "", locale: "en-US" };

  function readMoneyFormat(root) {
    var el = root.querySelector(".price--listing .price-item");
    var text = el ? el.textContent.trim() : "";
    var m = text.match(/[\d.,]+/);
    if (!m) return;
    var num = m[0];
    money.prefix = text.slice(0, text.indexOf(num)).replace(/^\D*?(\S+\s*)$/, "$1");
    money.suffix = text.slice(text.indexOf(num) + num.length);
    money.locale = num.lastIndexOf(",") > num.lastIndexOf(".") ? "nl-NL" : "en-US";
  }

  function euro(cents) {
    return money.prefix + (cents / 100).toLocaleString(money.locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + money.suffix;
  }

  function cached(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }

  function cache(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function fetchProduct(handle) {
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Leest een product uit: is er een optie "Club" met setwaarden ("... clubs)"),
     dan zitten losse ijzers en sets in hetzelfde product. */
  function readProduct(p) {
    if (!p || !p.variants || !p.variants.length) return null;

    var clubIndex = -1;
    var names = p.options || [];
    for (var i = 0; i < names.length; i++) {
      var name = typeof names[i] === "string" ? names[i] : names[i].name;
      if (name === "Club") clubIndex = i;
    }

    var out = { loose: null, set: null, setName: "" };

    if (clubIndex < 0) {
      for (var j = 0; j < p.variants.length; j++) {
        var pr = p.variants[j].price;
        if (out.loose === null || pr < out.loose) out.loose = pr;
      }
      return out;
    }

    var pref = null, prefName = "";
    for (var k = 0; k < p.variants.length; k++) {
      var v = p.variants[k];
      var club = (v.options && v.options[clubIndex]) || "";
      if (club.indexOf("clubs)") > -1) {
        if (out.set === null || v.price < out.set) { out.set = v.price; out.setName = club; }
        if (club.indexOf(SET_LABEL) > -1 && (pref === null || v.price < pref)) {
          pref = v.price; prefName = club;
        }
      } else if (out.loose === null || v.price < out.loose) {
        out.loose = v.price;
      }
    }
    if (pref !== null) { out.set = pref; out.setName = prefName; }
    return out;
  }

  function setPrice(card, cents) {
    var spans = card.querySelectorAll(".price--listing .price-item");
    for (var i = 0; i < spans.length; i++) spans[i].textContent = euro(cents);
  }

  function setFormat(card, text) {
    if (!text) return;
    var line = card.querySelector(".product--listing-format");
    if (line) {
      line.textContent = text;
      line.classList.remove("product--listing-format--placeholder");
      return;
    }
    var title = card.querySelector(".product--listing-title");
    if (!title || !title.parentNode) return;
    line = document.createElement("div");
    line.className = "product--listing-format";
    line.textContent = text;
    title.parentNode.insertBefore(line, title.nextSibling);
  }

  function addSingle(card, cents) {
    var info = card.querySelector(".product-info");
    if (!info || info.querySelector(".product--listing-single")) return;
    var el = document.createElement("div");
    el.className = "product--listing-single";
    el.textContent = LABEL + euro(cents);
    info.appendChild(el);
  }

  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute("href").match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function fill(card) {
    if (card.getAttribute("data-gs-done")) return;
    card.setAttribute("data-gs-done", "1");

    var handle = handleOf(card);
    if (!handle) return;

    var key = "gs-kaart:" + handle;
    var hit = cached(key);
    if (hit) { apply(card, hit); return; }

    var losseHandle = LOSSE[handle];

    if (losseHandle) {
      fetchProduct(losseHandle).then(function (p) {
        var data = readProduct(p);
        if (!data || data.loose === null) return;
        var result = { loose: data.loose, set: null, setName: "" };
        cache(key, result);
        apply(card, result);
      });
      return;
    }

    fetchProduct(handle).then(function (p) {
      var data = readProduct(p);
      /* Alleen bij geconsolideerde producten: daar is de laagste prijs een
         los ijzer en hoort de setprijs op de kaart. */
      if (!data || data.set === null || data.loose === null) return;
      cache(key, data);
      apply(card, data);
    });
  }

  function apply(card, data) {
    if (data.set) {
      setPrice(card, data.set);
      setFormat(card, data.setName);
    }
    if (data.loose) addSingle(card, data.loose);
  }

  function start() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    var cards = root.querySelectorAll(".featured__collection-product");
    if (!cards.length) return;

    readMoneyFormat(root);

    if (!("IntersectionObserver" in window)) {
      for (var i = 0; i < cards.length; i++) fill(cards[i]);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        fill(entry.target);
      });
    }, { rootMargin: "300px" });

    for (var j = 0; j < cards.length; j++) io.observe(cards[j]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
